import Parse from "parse";

const getRoundFromCode = (code = "") => {
  const m = code.match(/^[a-z]+([a-e])\d+$/i);
  return m ? m[1].toLowerCase() : null;
};

export const getRanking = async () => {
  const userId = localStorage.getItem("gameUserId");
  localStorage.getItem("gameUserId");
  const query = new Parse.Query(Parse.Object.extend("spyx"));
  query.exists("score");
  query.exists("clearTime");

  const now = new Date();
  const kstOffset = 9 * 60 * 60 * 1000;

  const startKST = new Date(now);
  startKST.setHours(0, 0, 0, 0);
  const start = new Date(startKST.getTime() - kstOffset);

  const endKST = new Date(now);
  endKST.setHours(23, 59, 59, 999);
  const end = new Date(endKST.getTime() - kstOffset);

  query.greaterThanOrEqualTo("createdAt", start);
  query.lessThanOrEqualTo("createdAt", end);
  query.limit(1000);

  const users = await query.find();

  console.log("✅ 랭킹 users 수:", users.length);

  if (users.length === 0) {
    return { sorted: [], myTeamRank: 0, myTeamName: "" };
  }

  const mapped = users.map((u) => ({
    objectId: u.id,
    keyCode: u.get("keyCode") || "",
    playerName: u.get("playerName") || "",
    introTeam: u.get("introTeam") || "",
    userRole: u.get("userRole") || "",
    score: u.get("score") || 0,
    suspectScore: u.get("suspectScore") || 0,
    clearTime: u.get("clearTime") || 0,
    introInCode: u.get("introInCode") || "",
    total: (u.get("score") || 0) + (u.get("suspectScore") || 0),
  }));

  // ✅ objectId로 내 entry 찾기
  const myEntry = mapped.find((u) => u.objectId === userId);
  const myInCode = myEntry?.introInCode || "";
  const myTeamName = myEntry?.introTeam || "";
  const myRound = getRoundFromCode(myInCode);

  console.log("✅ 내 objectId:", userId);
  console.log(
    "✅ 내 입장코드:",
    myInCode,
    "/ 내 회차:",
    myRound,
    "/ 내 팀명:",
    myTeamName,
  );

  // 같은 회차 필터
  const sameRound = myRound
    ? mapped.filter((u) => getRoundFromCode(u.introInCode) === myRound)
    : mapped;

  console.log("✅ 같은 회차 인원:", sameRound.length);

  // 팀명 기준으로 그룹화
  const teamMap = {};
  sameRound.forEach((u) => {
    const teamKey = u.introTeam || u.keyCode;
    if (!teamMap[teamKey]) teamMap[teamKey] = [];
    teamMap[teamKey].push(u);
  });

  // 팀별 대표 성적 = 역할 무관, 팀원 중 최고 성적 (점수 높은 순 → 동점이면 시간 빠른 순)
  const teamRanking = Object.values(teamMap)
    .map((members) => {
      const representative = [...members].sort((a, b) => {
        if (b.total !== a.total) return b.total - a.total;
        return a.clearTime - b.clearTime;
      })[0];

      return {
        introTeam: representative.introTeam,
        introInCode: representative.introInCode,
        playerName: representative.playerName,
        userRole: representative.userRole,
        score: representative.score,
        suspectScore: representative.suspectScore,
        clearTime: representative.clearTime,
        total: representative.total,
        members,
      };
    })
    .sort((a, b) => {
      if (b.total !== a.total) return b.total - a.total;
      return a.clearTime - b.clearTime;
    });

  console.log("✅ teamRanking:", teamRanking);

  const myTeamRank =
    teamRanking.findIndex((t) => t.introTeam === myTeamName) + 1;

  console.log("✅ myTeamName:", myTeamName, "/ myTeamRank:", myTeamRank);

  return { sorted: teamRanking, myTeamRank, myTeamName };
};
